import { ContactType } from "@libs/gateways/practice/PracticeGateway.dtos.ts";
import { routes } from "@libs/routing/routes.ts";
import { usePatientLabel } from "@ui-components/hooks/usePatientLabel.ts";
import { NavLink } from "@ui-components/navigation/Nav.tsx";

import { useAddContactLink } from "./useAddContactLink.ts";

export const useAddressBookLinks = (): NavLink[] => {
  const patientLabel = usePatientLabel(true);

  return [
    useAddContactLink(ContactType.Patient, {
      name: `New ${patientLabel.toLocaleLowerCase()}`,
      showBorder: true
    }),
    {
      name: `${patientLabel}s`,
      path: routes.addressBook.patient
    },
    {
      name: `Non-${patientLabel.toLocaleLowerCase()}s`,
      path: routes.addressBook.individuals
    },
    {
      name: "Organisations",
      path: routes.addressBook.organisations
    }
  ];
};
